export type MenuItemType = Required<any>['items'][number];

export const MenuItems: MenuItemType[] = [
  {
    key: "home",
    icon: "home",
    label: "home",
    link: "/portal"
  },
  // {
  //   key: "dashboard",
  //   icon: "dashboard",
  //   label: "dashboard",
  //   link: "/portal/dashboard"
  // },
  {
    key: "report",
    icon: "report",
    label: "report",
    link: "/portal/report"
  },
  {
    key: "discount-coupon",
    icon: "local_activity",
    label: "discount-coupon",
    link: "/portal/discount-coupon"
  },
  {
    key: "sms-panel",
    icon: "sms",
    label: "sms-panel",
    link: "/portal/sms-panel"
  },
  // {
  //   key: "team",
  //   icon: "account_circle",
  //   label: "Team",
  //   children: [
  //     {
  //       key: "team1",
  //       icon: "team",
  //       label: "Team 1",
  //       link: "/portal/team1"
  //     },
  //     {
  //       key: "team2",
  //       icon: "team",
  //       label: "Team 2",
  //       link: "/portal/team2"
  //     }
  //   ]
  // }
];
